import { useState } from 'react';
import { FolderOpen } from 'lucide-react';
import { Input } from '../shadComponents/ui/input';
import { Button } from '../shadComponents/ui/button';
import { Label } from '../shadComponents/ui/label';
import ImageInput from './components/ImageInput';

interface FlowStepInputProps {
    name: string;
    stepNumber: number;
    argumentType: string | undefined;
    value: string | number;
    onChange: (value: string | number) => void;
    onLaunchAssetPicker?: (callback: (value: string) => void) => void;
}
export default function FlowStepInput({
    name,
    stepNumber,
    argumentType = 'string',
    value,
    onChange,
    onLaunchAssetPicker,
}: FlowStepInputProps) {
    const [inputValue, setInputValue] = useState<string | number>(value);
    const isFileurl = argumentType === 'fileurl';

    const key = `${name}_${stepNumber}`;

    /*  useEffect(() => {
        if (value !== inputValue) {
            onChange(inputValue);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inputValue]);*/

    return (
        <div className="flex flex-row" key={key}>
            <div className="flex-col flex align-center space-y-1">
                <Label className="capitalize">{name}:</Label>
                <Input
                    type="text"
                    value={inputValue}
                    onBlur={() => {
                        onChange(inputValue);
                    }}
                    onChange={(e) => {
                        setInputValue(e.target.value);
                    }}
                    className="h-8 w-96"
                />
            </div>
            {isFileurl && (
                <div className="mr-4">
                    <Button
                        variant="outline"
                        size="sm"
                        className="mt-[21px]"
                        onClick={() => {
                            onLaunchAssetPicker &&
                                onLaunchAssetPicker((value) => {
                                    setInputValue(value);
                                    onChange(value);
                                });
                        }}
                    >
                        <FolderOpen className="size-4" />
                    </Button>
                </div>
            )}

            {isFileurl && (
                <ImageInput
                    image={value as string}
                    onImageChange={(value) => {
                        if (value) {
                            setInputValue(value);
                            onChange(value);
                        }
                    }}
                    key={value}
                />
            )}
        </div>
    );
}
